module.exports = __webpack_public_path__ + "static/img/Lapel Pin 1-1.17fc9b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Lapel Pin 1-1.jpg
// module id = aDXs
// module chunks = 1